import React from 'react';
import { ACTIVATION_SCHEDULED } from '../../../utils/violationSchedule';
import { getWeekdayLabel } from '../../../constants/violationConstants';

/*
 * P2-01 / read-only показ активации правила.
 *
 * Presence-driven: пока backend не отдаёт activation, блок не рисуется вовсе.
 * Термин legacy_always пользователю не показывается — legacy-правило выглядит
 * как обычное «Всегда активно» (ТЗ 3.3).
 */

const ActivationSummary = ({ activation }) => {
  if (!activation) return null;

  const scheduled = activation.mode === ACTIVATION_SCHEDULED;
  const windows = Array.isArray(activation.windows) ? activation.windows : [];

  return (
    <div className="vio-activation-summary">
      <div className="vio-readonly-label">Активация</div>
      <div className="vio-readonly-value">
        {scheduled ? `По расписанию, ${activation.timezone || '—'}` : 'Всегда активно'}
      </div>

      {scheduled && windows.length > 0 && (
        <ul className="vio-activation-list">
          {windows.map((window) => (
            <li key={window.window_id ?? `${window.weekday}-${window.start_time}`}>
              {getWeekdayLabel(window.weekday)} {window.start_time} — {window.end_time}
            </li>
          ))}
        </ul>
      )}

      {scheduled && activation.schedule_version != null && (
        <p className="vio-field-hint">Версия расписания {activation.schedule_version}</p>
      )}
    </div>
  );
};

export default ActivationSummary;
